// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"6deb04c0","703":"eb010a52"}[chunkId] + ".chunk.js";
};